module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_department02-011692e390e239bd970b9d78ebdd956c.png";